import { baseSiteEndPoint, buildHeaders } from "./common";
import { authorizedFetch } from "./login";

const acquirerPriorityUrl = () => `${baseSiteEndPoint}/unified/system-settings/acquirer-priority/`;

export const apiSystemAcquirerPriority = async () => {
  const response = await authorizedFetch(acquirerPriorityUrl(), {
    method: "GET",
    headers: buildHeaders(),
  });
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};

export const apiUpdateSystemAcquirerPriority = async (payload) => {
  const response = await authorizedFetch(acquirerPriorityUrl(), {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw await response.json();
  }
  return response.json();
};
